//@ts-nocheck
import { Registry } from '@react-registry'
import isUrl from 'is-url'

import { wrapLink, handleCursorIfCursorEndOfLink, isVisuallyEqualPoint, isSelectionEntirelyLink, getPartialLinkInfo } from './utils'
import { Editor, Transforms, Range, Path, Element, Node, Text, } from 'slate'
import { ReactEditor } from 'slate-react';

export const withHyperlinks = (editor) => {
  const { insertData, insertText, isInline, insertBreak, normalizeNode, deleteBackward, deleteForward, deleteFragment } = editor
  editor.isInline = (element) => {
    return element.type === 'a' ? !element?.attrs?.isBlock : isInline(element)
  }

  editor.insertText = (text) => {
    if (text && isUrl(text)) {
      wrapLink(editor, text)
    } else {
      if (/\s/g.test(text)) {
        const [anchorNode, anchorPath] = Editor.parent(editor, editor.selection)
        if (
          // Move cursor position to the next text node
          Range.isCollapsed(editor.selection) &&
          Editor.isEnd(editor, editor.selection.focus, anchorPath) &&
          (anchorNode.type === 'a' || anchorNode?.attrs?.['display-type'] === 'link')
        ) {
          Transforms.move(editor, { distance: 1, unit: 'offset' })
        }
      }
      insertText(text)
    }
  }

  editor.insertBreak = () => {
    const [selectedElement, path] = Editor.parent(editor, editor.selection);

    if (selectedElement.type === 'a' || selectedElement?.attrs?.['display-type'] === 'link') {
      const endPoint = Range.end(editor.selection);
      const [selectedLeaf] = Editor.node(editor, endPoint);
      //@ts-ignore
      if (selectedLeaf.text.length === endPoint.offset) {
        if (Range.isExpanded(editor.selection)) {
          Transforms.delete(editor);
        }
        // Transforms.select(editor, Path.next(path));
      }
    }
    handleCursorIfCursorEndOfLink(editor, isVisuallyEqualPoint);
    insertBreak();
  };

  editor.insertData = (data) => {
    const text = data.getData('text/plain')

    if (text && isUrl(text)) {
      wrapLink(editor, text)
    } else {
      insertData(data)
    }
  }

  editor.deleteBackward = (unit) => {
    const { selection } = editor;

    if (!Range.isCollapsed(selection)) {
      deleteBackward(unit);
      return;
    }

    const [node, nodePath] = Editor.node(editor, selection.focus);
    const [parentElement, parentPath] = Editor.parent(editor, selection.focus);

    if (parentElement.type === 'a' || parentElement?.attrs?.['display-type'] === 'link') {
      const linkText = Node.string(parentElement);

      if (selection.focus.offset === 0) {
        deleteBackward(unit);
        return;
      }

      // If link has only one character left, remove the entire link
      if (linkText.length <= 1) {
        Transforms.removeNodes(editor, { at: parentPath });
        return;
      }

      deleteBackward(unit);
      return;
    }
    deleteBackward(unit);
  }

  editor.deleteForward = (unit) => {
    const { selection } = editor;

    if (!Range.isCollapsed(selection)) {
      deleteForward(unit);
      return;
    }

    const [node, nodePath] = Editor.node(editor, selection.focus);
    const [parentElement, parentPath] = Editor.parent(editor, selection.focus);

    if (parentElement.type === 'a' || parentElement?.attrs?.['display-type'] === 'link') {
      const linkText = Node.string(parentElement);

      // Check if cursor is at the end of the link
      if (selection.focus.offset === linkText.length) {
        deleteForward(unit);
        return;
      }

      // If link has only one character left, remove the entire link
      if (linkText.length <= 1) {
        Transforms.removeNodes(editor, { at: parentPath });
        return;
      }

      deleteForward(unit);
      return;
    }
    deleteForward(unit);
  }

  editor.deleteFragment = (unit) => {
    const { selection } = editor

    if (selection) {
      const isEntirelyLink = isSelectionEntirelyLink(editor);
      const { hasPartialLink, linkParents } = getPartialLinkInfo(editor);
      
      if (isEntirelyLink) {
        const [node, path] = Editor.node(editor, selection);
        const [parent, parentPath] = Editor.parent(editor, path);
        const linkText = Node.string(parent);
        
        if (selection.anchor.offset === 0 && selection.focus.offset === linkText.length) {
          Transforms.removeNodes(editor, { at: parentPath });
          deleteFragment(unit);
          return;
        }
        deleteFragment(unit);
        return;
      } else if (hasPartialLink) {
    
        const linksToRemove = [];
        
        for (const { parent, parentPath } of linkParents) {
          const linkRange = Editor.range(editor, parentPath);
          const linkText = Node.string(parent);
          
          const isLinkFullySelected = 
            Range.includes(selection, linkRange.anchor) && 
            Range.includes(selection, linkRange.focus);
          
          if (isLinkFullySelected) {
            linksToRemove.push(parentPath);
          }
        }
        
        const sortedPaths = linksToRemove.sort((a, b) => Path.compare(b, a));
        for (const path of sortedPaths) {
          Transforms.removeNodes(editor, { at: path });
        }
        
        deleteFragment(unit);
        return;
      }
    }
    deleteFragment(unit);
  }
  return editor
}

Registry.register(withHyperlinks, { id: 'withHyperlinks', registry: 'plugin' })

